<template>
  <v-row class="ma-0" v-if="userLoggedIn">
    <v-col class="pa-0" v-if="localShoppingLists.length > 0">
      <v-row class="ma-0">
        <!--          <span>-->
        <!--            {{ localShoppingLists[selectedShoppingList].ShoppingListName }}-->
        <!--          </span>-->
        <!--          <v-btn-->
        <!--            icon-->
        <!--            v-if="isShoppingListAdmin(localShoppingLists[selectedShoppingList])"-->
        <!--            @click="-->
        <!--              userWantsToEditName(localShoppingLists[selectedShoppingList])-->
        <!--            "-->
        <!--          >-->
        <!--            <v-icon color="primary">mode_edit</v-icon>-->
        <!--          </v-btn>-->
        <!--      </v-row>-->

        <v-col align="end" class="d-flex flex-wrap bg-surface-variant">
          <v-btn
            v-if="isMobile"
            color="secondary"
            class="text-capitalize secondary-font-color flex-grow-1 ma-1"
            @click="browseProducts"
            >{{ $translate('ADD_PRODUCT') }}
          </v-btn>

        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
          <v-tabs
            v-model="selectedShoppingList"
            background-color="transparent"
            color="primary"
            grow
            center-active
            show-arrows
          >
            <v-tab
              v-for="(item, index) in localShoppingLists"
              :key="index"
              style="text-transform: none"
            >
              {{ item.ShoppingListName }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="selectedShoppingList">
            <v-tab-item
              v-for="(item, itemIndex) in localShoppingLists"
              :key="itemIndex"
              transition="slide-x-transition"
            >
              <v-card class="transparent" elevation="0">
                <v-row justify="center" class="ma-0">
                  <v-col cols="12" class="pa-0">
                    <v-card class="pa-0" outlined>
                      <ShoppingListProducts
                        :hideToolBar="true"
                        class="mb-2"
                        :shoppingList="item"
                        @add="() => onAddProduct(item)"
                        @item-change="onChangeProductItem"
                        @decrease="
                          (product) =>
                            onAddOrSubtractsProduct('subtracts', product)
                        "
                        @increase="
                          (product) => onAddOrSubtractsProduct('add', product)
                        "
                        @delete="(product) => onRemoveProduct(product)"
                      />
                      <v-divider />
                      <ShoppingListDiscounts
                        :discounts="getDiscountItems(item)"
                      />
                      <v-divider />
                      <ShoppingListTotalPrice :selectedShoppingList="item" />

                      <!--  Alert in case minimum value is not reached -->
                      <v-alert
                        v-if="showMinSubscriptionValue(item)"
                        type="warning"
                        class="mt-3"
                        transition="expand-transition"
                      >
                        {{ $translate('MIN_SUBSCRIPTION_VALUE_ALERT') }}:
                        <span class="font-weight-bold">
                          {{ formatter.format(minSubscriptionValue) }}
                        </span>
                      </v-alert>

                      <v-alert
                        class="mt-4"
                        type="info"
                        v-if="
                          item.DeliveryFee != null &&
                          item.DeliveryFee.DeliveryError &&
                          item.Type !== 'Subscription'
                        "
                      >
                        {{ item.DeliveryFee.DeliveryText }}
                      </v-alert>

                      <v-alert
                        v-if="minPickupFeeAlert"
                        class="mt-4"
                        type="warning"
                      >
                        {{ minPickupFeeAlert }}
                      </v-alert>

                      <!-- save as default shopping list and recover default list-->
                      <v-row justify="center" class="my-4">
                        <template
                          v-if="
                            item.Type !== 'WishList' &&
                            isShoppingListAdmin(item)
                          "
                        >
                          <v-btn
                            color="primary"
                            class="text-capitalize mx-2 mb-2 primary-font-color"
                            :loading="updatingSubscription"
                            @click="onUpdateSubscription"
                          >
                            {{ $translate('UPDATE_SUBSCRIPTION') }}
                          </v-btn>
                          <v-btn
                            color="primary"
                            class="text-capitalize mx-1 mb-2 primary-font-color"
                            :loading="resetingSubscription"
                            @click="onResetSubscription"
                          >
                            {{ $translate('RESET_SUBSCRIPTION') }}
                          </v-btn>
                        </template>

                        <!-- Button to copy list to cart -->
                        <v-btn
                          v-if="
                            item.Temporary &&
                            item.Products.length > 0 &&
                            isShoppingListAdmin(item)
                          "
                          color="primary"
                          class="text-capitalize mx-1 mb-2 primary-font-color"
                          @click="orderShoppingListNow(item)"
                        >
                          {{ $translate('COPY_TO_SHOPPINGCART') }}
                        </v-btn>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-card
                      class="pa-2"
                      style="min-height: 15em"
                      color="grey lighten-3"
                      flat
                      ><h2
                        :style="`color: ${$vuetify.theme.themes.light.primary}`"
                        class="text-center font-weight-bold "
                      >
                        {{ $translate('DETAILS') }}
                      </h2>
                      <!-- Show the selected PaymentMethod for this ShoppingList by the user -->
                      <v-card
                        v-if="selectedPaymentMethod.PaymentMethod"
                        class="ma-0 pa-0 mt-1 px-4 py-4"
                        outlined
                      >
                        <v-col class="pa-0">
                          <h2
                            :style="`color: ${$vuetify.theme.themes.light.primary}`"
                            class="mb-2"
                          >
                            {{ $translate('SELECTED_PAYMENT_METHOD') }}
                          </h2>
                          <v-row class="ma-0 d-inline-flex">
                            <v-img
                              :src="selectedPaymentMethod.PictureUrl"
                              max-width="45px"
                              max-height="45px"
                            />
                            <span class="ml-6">
                              {{ selectedPaymentMethod.DisplayName }}
                            </span>
                          </v-row>
                          <p class="mt-2" v-if="!isMobile">
                            {{ paymentMethodInfoText }}
                          </p>
                        </v-col>
                      </v-card>

                      <v-row justify="center" class="ma-0 mt-4">
                        <!-- Button to choose delivery date/time by admin -->
                        <v-btn
                          v-if="
                            isShoppingListAdmin(item) &&
                            item.Products.length &&
                            item.Temporary
                          "
                          color="primary"
                          class="text-capitalize mb-3 primary-font-color"
                          @click="makeShopListDefinite(item)"
                        >
                          {{ $translate('PICK_YOUR_MOMENT') }}
                        </v-btn>

                        <!-- Button to skip next schedule by admin -->
                        <v-btn
                          v-if="
                            isShoppingListAdmin(item) &&
                            item.Products.length &&
                            !item.Temporary&& item.Frequency !== 0
                          "
                          block
                          color="secondary"
                          class="text-capitalize ma-1 mx-4"
                          :disabled="skipDeliveryBtnDisabled"
                          @click="onSkipDelivery"
                        >
                          {{ $translate('SKIP_DELIVERY') }}
                        </v-btn>

                        <!-- Button to pay scheduled list by admin -->
                        <v-btn
                          v-if="
                            isShoppingListAdmin(item) &&
                            item.Products.length &&
                            !item.Temporary &&
                            item.Type !== 'Subscription'
                          "
                          block
                          color="primary"
                          class="text-capitalize ma-1 mx-4 mb-2 primary-font-color"
                          @click="userWantsToPayShoppingList(item)"
                          :loading="loading"
                          :disabled="
                            item.DeliveryFee != null &&
                            item.DeliveryFee.DeliveryError
                          "
                        >
                          {{ $translate('PAY_NOW') }}
                        </v-btn>
                      </v-row>
                      <ShoppingListDetails :shoppingList="item" />
                      <!--cancel and delete buttons-->
                      <v-row justify="center" class="ma-0 mt-3">
                        <!-- Button to cancel order -->
                        <v-btn
                          v-if="
                            isShoppingListAdmin(item) &&
                            item.Products.length &&
                            !item.Temporary &&
                            item.Type !== 'Subscription'
                          "
                          class="text-capitalize mr-2 mb-3"
                          color="secondary"
                          @click="triggerCancelOrderDialog(item)"
                        >
                          {{ $translate('CANCEL_ORDER') }}
                        </v-btn>
                        <!-- Button to delete list -->
                        <v-btn
                          v-if="isShoppingListAdmin(item)"
                          class="text-capitalize white--text"
                          color="red accent-3"
                          @click="triggerDeleteShoppingListDialog(item)"
                        >
                          {{ $translate('DELETE') }}
                        </v-btn>
                      </v-row>
                      <v-row class="ma-2">
                        <v-btn
                          color="secondary"
                          class="text-capitalize secondary-font-color flex-grow-1 ma-1"
                          @click="onCreateShoppingList"
                        >{{ $translate('CREATE_NEW_LIST') }}</v-btn
                        >
                        <v-btn
                          color="secondary"
                          class="text-capitalize secondary-font-color flex-grow-1 ma-1"
                          @click="openActivities"
                        >{{ $translate('VIEW_ORDER') }}</v-btn
                        >

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="secondary"
                              class="text-capitalize secondary-font-color flex-grow-1 ma-1"
                              @click="onAddUser"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-account-group</v-icon
                              ><v-icon>mdi-share-variant</v-icon>
                            </v-btn>
                          </template>
                          <span> {{ $translate('SHARE_SHOPPING_LISTS') }}</span>
                        </v-tooltip>
                      </v-row>

                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
              <ShoppingList_Booking
                v-if="makeShopListDefiniteBoolean"
                :shoppingList="toUpShoppingList"
                @closeShopListDefiniteDialog="closeShopListDefiniteDialog"
                @openSuccessDefiniteDialog="openSuccessDefiniteDialog"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="pa-0 pt-6 px-4" cols="12" v-else>
      <ShoppingListsNoData
        v-if="localShoppingLists.length === 0"
        :cardHeight="60"
        class="py-12"
        @take-subscription="onCreateSubscription"
        @create-list="onCreateShoppingList"
      />
    </v-col>
    <!-- Success dialog -->
    <SuccessDialog
      :dialog="successDialog"
      :successText="paymentMsg"
      @continue="goToMyActivities()"
      @back="
        successDialog = false;
        setDialog(false);
      "
    />

    <!-- Dialog to share shopping list-->
    <template v-if="showUserSharingDialog">
      <ShareShoppingList
        :showUserSharingDialog="showUserSharingDialog"
        :userRelationsAsParent="userRelationsAsParent"
        @refreshShoppingList="refreshShoppingList"
        @close="onCloseUserSharingDialog"
      >
      </ShareShoppingList>
    </template>

    <!-- Dialog to create new list -->
    <template v-if="showNewListDialog">
      <ShoppingListNewList
        :visible="showNewListDialog"
        @close="showNewListDialog = false"
        @saved="onNewListCreated"
      />
    </template>

    <!-- Dialog to confirm skipping next delivery -->
    <ConfirmDialog
      :visible="showSkipDeliveryDialog"
      :title="$translate('SKIP_DELIVERY_CONFIRM_TITLE')"
      :message="$translate('SKIP_DELIVERY_CONFIRM_MESSAGE')"
      :positiveBtnText="$translate('YES')"
      :negativeBtnText="$translate('NO')"
      @positiveBtnClicked="onSkipDeliveryConfirmed"
      @negativeBtnClicked="onSkipDeliveryCancelled"
    />

    <!-- Dialog to confirm payment for the list -->
    <v-dialog
      hide-overlay
      v-model="userWantsToPayDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline" style="word-break: normal">
          {{ $translate('PAY_SHOPPING_LIST_TITLE') }}
        </v-card-title>
        <v-card-text style="word-break: normal">
          {{ $translate('PAY_SHOPPING_LIST_MESSAGE') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="userWantsToPayDialog = false">
            {{ $translate('NO') }}
          </v-btn>
          <v-btn
            color="primary"
            class="primary-font-color"
            text
            @click="payShoppingList()"
          >
            {{ $translate('YES') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog to cancel the order -->
    <v-dialog
      hide-overlay
      v-model="cancelOrderDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline" style="word-break: normal">
          <div>{{ $translate('CANCEL_SHOPPINGLIST') }}</div>
        </v-card-title>
        <v-card-text style="word-break: normal">
          <div>{{ $translate('SURE_CANCEL_SHOPPINGLIST') }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mr=4"
            color="secondary"
            text
            @click="cancelOrderDialog = false"
          >
            {{ $translate('NO') }}
          </v-btn>
          <v-btn
            color="primary"
            class="primary-font-color"
            text
            @click="cancelOrder()"
          >
            {{ $translate('YES') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog to delete the list -->
    <v-dialog
      hide-overlay
      v-model="deleteShoppingListDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline" style="word-break: normal">
          <div v-if="toDeleteShoppingList.Type === 'Subscription'">
            {{ $translate('DELETE_SUBSCRIPTION_TITLE') }}
          </div>
          <div v-else>{{ $translate('DELETE_SHOPPINGLIST') }}</div>
        </v-card-title>
        <v-card-text style="word-break: normal">
          <div v-if="toDeleteShoppingList.Type === 'Subscription'">
            {{ $translate('DELETE_SUBSCRIPTION_DESC') }}
          </div>
          <div v-else>{{ $translate('SURE_DELETE_SHOPPINGLIST') }}</div>
          <div class="font-weight-bold mt-1">
            {{ toDeleteShoppingList.ShoppingListName }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="deleteShoppingListDialog = false"
          >
            {{ $translate('CANCEL') }}
          </v-btn>
          <v-btn
            color="primary"
            class="primary-font-color"
            text
            @click="deleteShoppingList()"
          >
            {{ $translate('DELETE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Success definite dialog -->
    <v-dialog max-width="500" v-model="successDefiniteDialog" persistent>
      <v-card class="text-center">
        <v-card-title class="justify-center">
          <v-icon color="green" size="128">check_circle</v-icon>
        </v-card-title>
        <v-card-text
          style="word-break: normal"
          class="justify-center mt-5 pb-4"
        >
          <div class="mb-3">
            {{ $translate('SUCCESS_SELECTED_SHOPPING_LIST_MOMENT') }}
          </div>
          <div>
            {{ $translate('SUCCESS_SELECTED_SHOPPING_LIST_MOMENT_EXTRA') }}
          </div>
        </v-card-text>
        <v-card-actions class="pb-3">
          <v-btn
            color="primary"
            depressed
            block
            large
            @click="successDefiniteDialog = false"
          >
            {{ $translate('CLOSE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog to change list name -->
    <v-dialog
      hide-overlay
      v-model="changeNameDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline" style="word-break: normal">
          {{ $translate('CHANGE_SHOPPINGLIST_NAME') }}
        </v-card-title>
        <v-col cols="11">
          <v-text-field
            v-model="nameToChange"
            :label="$translate('SHOPPING_LIST_NAME')"
            outlined
            required
          />
        </v-col>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" text @click="changeNameDialog = false">
            {{ $translate('CLOSE') }}
          </v-btn>
          <v-btn
            color="primary"
            class="primary-font-color"
            text
            @click="saveShoppingList('exist')"
          >
            {{ $translate('SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog to get user decision -->
    <ConfirmDialog
      :visible="showConfirmDialog"
      :title="confirmDialogTitle"
      :message="confirmDialogMsg"
      :positiveBtnText="confirmDialogPosBtnText"
      :negativeBtnText="confirmDialogNegBtnText"
      @positiveBtnClicked="onConfirmDialogPosBtnClick"
      @negativeBtnClicked="onConfirmDialogNegBtnClick"
    />

    <!-- Progress circular -->
    <v-overlay :class="showProgress ? '' : 'd-none'" absolute color="grey">
      <v-progress-circular indeterminate color="primary" />
    </v-overlay>
  </v-row>
  <v-row class="ma-0" v-else>
    <v-row>
      <v-col align="center" cols="12" class="pa-0 pa-4 ma-4">
        <h4>{{ $translate('LOGIN_REQUIRED_SHOPPING_LIST') }}</h4>
        <v-btn
          large
          color="secondary"
          class="secondary-font-color mt-2"
          @click="login"
        >
          {{ $translate('LOGIN') }}</v-btn
        >
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import ShoppingListProducts from '@/components/shoppingLists/ShoppingListProducts';
import ShoppingListTotalPrice from '@/components/shoppingLists/ShoppingListTotalPrice';
import ShoppingListDiscounts from '@/components/shoppingLists/ShoppingListDiscounts';
import ShareShoppingList from '@/components/shoppingLists/ShareShoppingList';
import { scrollToElement } from '@/shared/utility';
import UserObject from '@/objects/UserObject';
import { getItemByDefs } from '@/objects/Product';
import ShoppingListsNoData from '@/components/shoppingLists/ShoppingListsNoData';
import {
  getShoppingLists,
  skipDelivery,
  getAwardedGrowthVitaminCards,
  changeProductOnReservation,
  removeProductFromReservation,
  isShoppingListAdmin,
  payShoppingList,
  makeShoppingListTemporary,
  deleteShoppingList,
  saveShoppingList,
  updateShoppingListProductsToCurrentOrder,
  resetOrderToShoppingList,
  orderShoppingListNow,
} from '@/objects/ShoppingList';
import { mapGetters, mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import ShoppingListNewList from '@/components/generalComponents/header/ShoppingListNewList.vue';
import PaymentMethod from '@/objects/PaymentMethod';
import ShoppingListDetails from '@/components/shoppingLists/ShoppingListDetails';
import ConfirmDialog from '@/components/generalComponents/uiComponents/ConfirmDialog';
import ShoppingList_Booking from '@/components/generalComponents/header/ShoppingList_Booking.vue';
import SuccessDialog from '@/components/generalComponents/uiComponents/SuccessDialog.vue';
import PickupFeeJS from '@/objects/PickupFee';

export default {
  name: 'ShoppingListProfessionalView',
  components: {
    SuccessDialog,
    ShoppingList_Booking,
    ShoppingListNewList,
    ShoppingListDiscounts,
    ShoppingListTotalPrice,
    ShoppingListProducts,
    ShareShoppingList,
    ShoppingListDetails,
    ConfirmDialog,
    ShoppingListsNoData,
  },
  data() {
    return {
      loading: false,
      userWantsToPayDialog: false,
      localShoppingLists: [],
      toPayShoppingList: {},
      selectedShoppingList: 0,
      latestTimestamp: 0,
      changeItemTimeOut: 0.3 * 1000,
      availableShoppingLists: [],
      showProgress: false,
      showUserSharingDialog: false,
      showNewListDialog: false,
      toUpShoppingList: {},
      makeShopListDefiniteBoolean: false,
      skipDeliveryBtnDisabled: false,
      showSkipDeliveryDialog: false,
      selectedPaymentMethod: new PaymentMethod(),
      toCancelShoppingList: {},
      cancelOrderDialog: false,
      toDeleteShoppingList: {},
      deleteShoppingListDialog: false,
      successDefiniteDialog: false,
      successDialog: false,
      paymentMsg: '',
      nameToChange: '',
      idWithChangeName: '',
      changeNameDialog: false,

      updatingSubscription: false,
      resetingSubscription: false,

      confirmDialogTitle: '',
      confirmDialogMsg: '',
      confirmDialogPosBtnText: '',
      confirmDialogNegBtnText: '',
      confirmDialogPosBtnHandler: undefined,
      confirmDialogNegBtnHandler: undefined,
      showConfirmDialog: false,

      minPickupFeeAlert: '',
      pickupFee: null,
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapState('shoppingList', {
      shoppingLists: (state) => state.orders,
    }),
    ...mapGetters({
      currentSelectedShoppingList: 'getCurrentSelectedShoppingList',
    }),
    minSubscriptionValue() {
      let minValue = 0;
      const pgInfo = this.$store.getters['Account/partnerGroupDetails'];
      if (pgInfo != null && pgInfo.SubscriptionMinimumOrderValue != null) {
        minValue = pgInfo.SubscriptionMinimumOrderValue;
      }
      return minValue;
    },
    userRelationsAsParent() {
      return this.$store.getters['auth/userRelationsAsParent'];
    },
    paymentMethodInfoText() {
      if (this.currentSelectedShoppingList.Type !== 'Subscription') {
        return this.$translate('SELECTED_PAYMENT_METHOD_INFO_LIST');
      } else {
        return this.$translate('SELECTED_PAYMENT_METHOD_INFO_SUBSC');
      }
    },
    userId() {
      return this.$store.getters['auth/userName'];
    },
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
  },
  created() {
    window.EventBus.listen('request-accepted', this.reloadUserData);
    this.loadData();
  },
  beforeDestroy() {
    window.EventBus.removeListener('request-accepted', this.reloadUserData);
  },
  watch: {
    selectedShoppingList() {
      if (this.hasValidSelection()) {
        const list = this.localShoppingLists[this.selectedShoppingList];
        this.$store.commit('setCurrentSelectedShoppingList', list);

        // this.getDeliveryFee();
        this.getPickupFee();
        this.initPaymentMethod();

        this.getAwardedGrowthVitaminCardsForList();
      } else {
        this.$store.commit('setCurrentSelectedShoppingList', {});
      }
    },
    shoppingLists() {
      this.initLists();
    },
  },
  methods: {
    getShoppingLists,
    initLists() {
      this.localShoppingLists = [];
      if (this.shoppingLists != null) {
        this.localShoppingLists = cloneDeep(this.shoppingLists);
      }

      this.initAllProducts();
      this.initSelectedList();
    },
    initSelectedList() {
      if (this.hasValidSelection()) {
        // this.getDeliveryFee();
        this.getPickupFee();
        this.initPaymentMethod();
        this.getAwardedGrowthVitaminCardsForList();
      }
    },
    initAllProducts() {
      this.localShoppingLists.forEach((list) => {
        this.initProducts(list);
      });
    },
    initProducts(list) {
      list.Products.forEach((product) => {
        this.initProduct(product);
      });
      this.initOrderProducts(list);
    },
    initOrderProducts(list) {
      /*
      Main purpose is to add missing ItemDefs for each product in the order of a shopping list
      Shopping list => Order => Product
      */
      if (list.OrderGroup != null && list.OrderGroup.Orders != null) {
        list.OrderGroup.Orders.forEach((order) => {
          order.Products.forEach((product) => {
            // Get product from Products array
            const prodInList = list.Products.find(
              (el) => el.ProductId === product.ProductId
            );

            if (prodInList != null) {
              product.Product = { ...prodInList.Product };

              const prodItem = prodInList.Product.Items.find(
                (el) => el.ItemId === product.ItemId
              );

              if (prodItem != null) {
                product.Capacity = prodItem.Capacity;
              }
            }

            product.OrderId = order.OrderId;
            product.EventId = order.EventId;
            product.ItemDef = product.Aspects;
            product.Price = product.ItemTotalPrice;

            this.initProduct(product);
          });
        });
      }
    },
    initProduct(product) {
      this.initProductItemDefs(product);

      // To keep track of quantity change
      product._oldQuantity = product.Quantity;
    },
    initProductItemDefs(product) {
      product.ItemDefObj = {};
      const item = product.Product.Items.find(
        (itemInList) => itemInList.Id === product.ItemId
      );
      if (item != null) {
        product.ItemDefObj = { ...item.ItemDef };
      }
    },
    // changeShoppingList() {
    //   if (this.hasValidSelection()) {
    //     const list = this.localShoppingLists[this.selectedShoppingList];
    //     this.$store.commit('setCurrentSelectedShoppingList', list);
    //     this.selectedShoppingList = list;
    //     this.initProducts(this.selectedShoppingList);
    //   }
    // },
    hasValidSelection() {
      if (
        this.selectedShoppingList != null &&
        this.selectedShoppingList >= 0 &&
        this.localShoppingLists != null &&
        this.localShoppingLists.length > 0 &&
        this.selectedShoppingList < this.localShoppingLists.length
      ) {
        return true;
      }
      return false;
    },

    getCurrentShoppingList(item) {
      const timeStamp = item.DeadLineUnix * 1000;
      const dateObj = new Date(timeStamp);

      if (dateObj > this.latestTimestamp) {
        this.selectedShoppingList = item;
        this.initProducts(this.selectedShoppingList);
      }
    },
    onAddProduct(shoppingList) {
      // User wants to add more products to current list
      this.$store.commit('setCurrentSelectedShoppingList', shoppingList);

      if (this.$route.name !== 'Homepage') {
        this.$router.push({
          name: 'Homepage',
          params: { scrollTo: 'categoriesScroll' },
        });
      } else {
        scrollToElement('#allCategories');
      }

      this.setDialog(false);
    },
    browseProducts() {
      scrollToElement('#categoriesProfView');
    },
    setDialog(active) {
      this.dialog = active;
      this.$store.commit('shoppingList/setActive', active);
    },
    onChangeProductItem(product) {
      // Add timeout id to the product to delay the backend request
      if (typeof product._timeoutId === 'number') {
        clearTimeout(product._timeoutId);
      }

      product._timeoutId = setTimeout(() => {
        this.changeItem(product);
      }, this.changeItemTimeOut);
    },
    changeItem(product) {
      const item = getItemByDefs(product.Product, product.ItemDefObj);

      if (
        product.Quantity === product._oldQuantity &&
        item.Id === product.ItemId
      ) {
        // Neither quantity nor item def is changed. No need to change item
        return;
      }

      const list = this.localShoppingLists[this.selectedShoppingList];
      const payload = {
        ShoppingListId: list.ShoppingListId,
        OrderId: product.OrderId,
        EventId: product.EventId,
        ProductId: product.ProductId,
        ItemId: product.ItemId,
        NewItemId: item.Id,
        Quantity: product.Quantity,
      };

      if (product.TemporaryOrderItemId) {
        // Unique id of the selection for Wishlist
        payload.TemporaryOrderItemId = product.TemporaryOrderItemId;
      } else if (product.OrderItemId) {
        // Unique id of the selection for ShoppingList
        payload.OrderItemId = product.OrderItemId;
      }

      this.showProgress = true;

      changeProductOnReservation(payload)
        .then(() => {})
        .catch((error) => {
          this.getLocalShoppingLists();

          if (error.data.ErrorCode === 'E_PO_006') {
            window.EventBus.fire(
              'activateErrorDialog',
              this.$translate('E_PO_006_PRODUCT'),
              false
            );
          } else {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('FAILED_ADD_SHOPPINGLIST')
            );
          }
        })
        .finally(() => {
          this.showProgress = false;
        });
    },
    onAddOrSubtractsProduct(action, product) {
      console.log('product - from parent', product);
      switch (action) {
        case 'add':
          if (product.Product.Type === 'Weighted') {
            product.Quantity += product.Product.WeightedInfo.StepSize;
          } else {
            product.Quantity += 1;
          }
          break;
        case 'subtracts':
          if (product.Product.Type === 'Weighted') {
            product.Quantity -= product.Product.WeightedInfo.StepSize;
          } else {
            product.Quantity -= 1;
          }
          break;
        default:
          break;
      }

      this.onChangeProductItem(product);
    },
    onRemoveProduct(product) {
      const list = this.localShoppingLists[this.selectedShoppingList];

      const payload = {
        ShoppingListId: list.ShoppingListId,
        OrderId: product.OrderId,
        EventId: product.EventId,
        ProductId: product.ProductId,
        ItemId: product.ItemId,
      };

      if (product.TemporaryOrderItemId) {
        // Unique id of the selection for Wishlist (no order yet)
        payload.TemporaryOrderItemId = product.TemporaryOrderItemId;
      } else if (product.OrderItemId) {
        // Unique id of the selection for ShoppingList (order already created)
        payload.OrderItemId = product.OrderItemId;
      }

      this.showProgress = true;

      removeProductFromReservation(payload)
        .then((response) => {
          if (response.data.ShoppingList != null) {
            this.updateSelectedShoppingList(response.data.ShoppingList);
          } else {
            this.getLocalShoppingLists();
          }
        })
        .catch(() => {
          window.EventBus.fire(
            'activateSnackBar',
            this.$translate('REMOVE_ITEM_ERROR')
          );
        })
        .finally(() => {
          this.showProgress = false;
        });
    },
    updateSelectedShoppingList(list) {
      if (!this.hasValidSelection()) {
        return;
      }

      this.initProducts(list);
      this.localShoppingLists[this.selectedShoppingList] = { ...list };
      this.initSelectedList();
    },
    getDiscountItems(list) {
      let discounts = [];

      if (list.OrderGroup != null) {
        list.OrderGroup.Orders.forEach((order) => {
          discounts.push(...order.Discounts);
        });
      }

      return discounts;
    },
    async onAddUser() {
      const localListId = this.localShoppingLists[this.selectedShoppingList].ShoppingListId;
      console.log(localListId);
      
      await this.getShoppingLists();
      
      setTimeout(() => {
        const listExists = this.localShoppingLists.some(list => list.ShoppingListId === localListId);

        if (listExists) {
          this.showUserSharingDialog = true;
        } else {
          this.alreadyDeletedList();
        }
      }, 500); 
    },
    onCloseUserSharingDialog() {
      this.showUserSharingDialog = false;
    },
    reloadUserData() {
      let userDataObj = new UserObject();
      userDataObj.getUserData();
    },
    refreshShoppingList() {
      this.reloadUserData();
      this.onCloseUserSharingDialog();
    },
    loadData() {
      this.getLocalShoppingLists();
      this.initLists();
    },

    getLocalShoppingLists() {
      if (!this.userLoggedIn) {
        return;
      }
      this.showProgress = true;
      try {
        const response = getShoppingLists();
        this.showProgress = false;

        const lists = response.data.ShoppingLists;
        this.$store.commit('shoppingList/setOrders', lists);

        if (lists.length <= 0) {
          this.$store.commit('setCurrentSelectedShoppingList', {});

          if (Object.keys(this.currentSelectedShoppingList).length > 0) {
            // Has selected list, try to locate this list
            const currentIndex = lists.findIndex(
              (list) =>
                list.ShoppingListId ===
                this.currentSelectedShoppingList.ShoppingListId
            );

            if (currentIndex !== -1) {
              // Current list found, show current list
              this.selectedShoppingList = currentIndex;
            } else if (lists.length > 0) {
              // Current list not found, but user has lists, show the first one
              this.selectedShoppingList = 0;
            } else {
              this.selectedShoppingList = -1;
            }
          } else if (lists.length > 0) {
            this.selectedShoppingList = 0;
          } else {
            this.selectedShoppingList = -1;
          }
        }
      } catch (error) {
        this.showProgress = false;
      }
    },

    getAwardedGrowthVitaminCardsForList() {
      let listId = null;
      if (this.hasValidSelection()) {
        const list = this.localShoppingLists[this.selectedShoppingList];
        listId = list.ShoppingListId;
      }

      this.suggestions = [];
      getAwardedGrowthVitaminCards(listId)
        .then((response) => {
          if (response.data.Suggestions != null) {
            this.suggestions = [...response.data.Suggestions];
          }
        })
        .catch(() => {});
    },
    onCreateShoppingList() {
      this.showNewListDialog = true;
    },
    onNewListCreated() {
      this.showNewListDialog = false;
      this.getShoppingLists();
    },
    initPaymentMethod() {
      const list = this.localShoppingLists[this.selectedShoppingList];

      if (list == null || list.PaymentMethod == null) {
        this.selectedPaymentMethod = new PaymentMethod();
        return;
      }

      this.selectedPaymentMethod = new PaymentMethod(list.PaymentMethod, false);
    },
    isShoppingListAdmin(shoppingList) {
      return isShoppingListAdmin(shoppingList);
    },
    makeShopListDefinite(shopList) {
      this.toUpShoppingList = {};
      this.toUpShoppingList = shopList;
      this.makeShopListDefiniteBoolean = true;
    },
    closeShopListDefiniteDialog() {
      this.toUpShoppingList = {};
      this.makeShopListDefiniteBoolean = false;
    },
    onSkipDelivery() {
      // User wants to skip the next delivery, show dialog to confirm this action
      this.showSkipDeliveryDialog = true;
    },
    async onSkipDeliveryConfirmed() {
      this.skipDeliveryBtnDisabled = true;
      this.showSkipDeliveryDialog = false;
      this.showProgress = true;

      const payload = {
        ShoppingListId:
          this.localShoppingLists[this.selectedShoppingList].ShoppingListId,
      };
      try {
        await skipDelivery(payload);
        this.showProgress = false;
        this.skipDeliveryBtnDisabled = false;
        this.getLocalShoppingLists();
      } catch (error) {
        this.showProgress = false;
        this.skipDeliveryBtnDisabled = false;
      }
    },
    onSkipDeliveryCancelled() {
      this.showSkipDeliveryDialog = false;
    },
    userWantsToPayShoppingList(item) {
      this.toPayShoppingList = item;
      this.userWantsToPayDialog = true;
    },
    async payShoppingList() {
      this.loading = true;
      this.userWantsToPayDialog = false;

      const payload = {
        ShoppingListId: this.toPayShoppingList.ShoppingListId,
      };
      try {
        const response = await payShoppingList(payload);
        this.loading = false;
        this.toPayShoppingList = {};

        switch (response.data.Status) {
          case 'PartnerConfirmation':
            // Need to wait for partner's response
            console.log('Order needs to be confirmed by partner');
            this.successDialog = true;
            this.paymentMsg = this.$translate(
              'ORDER_WAIT_FOR_PARTNER_CONFIRMATION'
            );
            break;
          case 'Confirmed':
            // Order confirmed by payment method of DirectDebit or free of charge
            console.log('Order already been confirmed');
            if (
              response.data.PaymentMessage != null &&
              response.data.PaymentMessage.trim() !== ''
            ) {
              this.paymentMsg = response.data.PaymentMessage;
            } else {
              this.paymentMsg = this.$translate('ORDER_COMPLETED_DEFAULT');
            }
            this.successDialog = true;
            break;
          case 'WaitingForPayment':
            // Waiting for payment, redirect to mollie
            console.log('Order waiting for payment');
            if (
              response.data.PaymentUrl != null &&
              response.data.PaymentUrl.trim() !== ''
            ) {
              setTimeout(() => {
                this.redirectPayment(response.data.PaymentUrl);
              }, 0);
            } else {
              window.EventBus.fire('activateSnackBar', {
                text: this.$translate('BOOKING_FAIL'),
                color: 'error',
              });
            }
            break;
          default:
            console.log('Unknown order status: ', response.data.Status);
            this.paymentMsg = this.$translate('ORDER_COMPLETED_DEFAULT');
            this.successDialog = true;
            break;
        }
        this.getLocalShoppingLists();
      } catch (error) {
        this.loading = false;
        this.getLocalShoppingLists();
        if (error.data.ErrorCode === 'E_DEL_002') {
          window.EventBus.fire('activateSnackBar', {
            text: this.$translate('E_DEL_002'),
            color: 'error',
          });
        } else {
          window.EventBus.fire('activateSnackBar', {
            text: this.$translate('BOOKING_FAIL'),
            color: 'error',
          });
        }
      }
    },
    triggerCancelOrderDialog(shoppingList) {
      this.toCancelShoppingList = {};
      this.toCancelShoppingList = shoppingList;
      this.cancelOrderDialog = true;
    },
    async cancelOrder() {
      const payload = {
        ShoppingListId: this.toCancelShoppingList.ShoppingListId,
      };
      try {
        await makeShoppingListTemporary(payload);
        this.toCancelShoppingList = {};
        this.cancelOrderDialog = false;
        this.getLocalShoppingLists();
      } catch (error) {
        console.log('ERROR', error);
      }
    },
    triggerDeleteShoppingListDialog(shoppingList) {
      this.toDeleteShoppingList = {};
      this.toDeleteShoppingList = shoppingList;
      this.deleteShoppingListDialog = true;
    },
    async deleteShoppingList() {
      this.showProgress = true;
      const payload = {
        ShoppingListId: this.toDeleteShoppingList.ShoppingListId,
      };
      try {
        await deleteShoppingList(payload);
        this.showProgress = false;
        this.toDeleteShoppingList = {};
        this.deleteShoppingListDialog = false;
        this.$store.commit('setCurrentSelectedShoppingList', {});
        this.getLocalShoppingLists();
      } catch (error) {
        if (error.data.ErrorCode === "E_SL_017") {
          this.getShoppingLists();
          this.alreadyDeletedList();
        }
        this.showProgress = false;
      }
    },
    alreadyDeletedList() {
      window.EventBus.fire('activateSnackBar', {
        text: this.$translate('SHOPPING_LIST_NO_LONGER_EXISTS'),
        color: 'error',
      });
      this.deleteShoppingListDialog = false;
    },
    openSuccessDefiniteDialog() {
      this.successDefiniteDialog = true;
      this.getLocalShoppingLists();
    },
    goToMyActivities() {
      this.successDialog = false;
      this.setDialog(false);
      this.$router.push({
        name: 'UserSettings',
        params: { myOrders: true },
      });
    },
    userWantsToEditName(item) {
      this.nameToChange = item.ShoppingListName;
      this.idWithChangeName = item.ShoppingListId;
      this.changeNameDialog = true;
    },
    async saveShoppingList(flow) {
      this.loading = true;
      const payload = {};

      if (flow === 'create') {
        payload.ShoppingListId = '';
      } else {
        payload.ShoppingListId = this.idWithChangeName;
      }

      payload.ShoppingListName = this.nameToChange;

      try {
        const response = await saveShoppingList(payload);
        this.$store.commit(
          'setCurrentSelectedShoppingList',
          response.data.ShoppingList
        );
        this.nameToChange = '';
        this.idWithChangeName = '';
        this.loading = false;
        this.getLocalShoppingLists();
        if (this.changeNameDialog) this.changeNameDialog = false;
      } catch (error) {
        this.loading = false;
        console.log('ERROR', error);
      }
    },

    onUpdateSubscription() {
      this.confirmDialogTitle = this.$translate('UPDATE_SUBSCRIPTION');
      this.confirmDialogMsg = this.$translate('UPDATE_SUBSCRIPTION_DIALOG_MSG');
      this.confirmDialogPosBtnText = this.$translate('YES');
      this.confirmDialogNegBtnText = this.$translate('NO');
      this.confirmDialogPosBtnHandler = () => {
        this.updateSubscription();
      };
      this.showConfirmDialog = true;
    },
    updateSubscription() {
      this.updatingSubscription = true;
      const list = this.localShoppingLists[this.selectedShoppingList];
      const payload = { ShoppingListId: list.ShoppingListId };
      updateShoppingListProductsToCurrentOrder(payload)
        .then(() => {
          this.getLocalShoppingLists();
          this.updatingSubscription = false;
        })
        .catch(() => {
          this.updatingSubscription = false;
        });
    },
    onConfirmDialogPosBtnClick() {
      this.showConfirmDialog = false;
      if (typeof this.confirmDialogPosBtnHandler !== 'function') {
        this.confirmDialogPosBtnHandler = undefined;
        return;
      }

      this.confirmDialogPosBtnHandler();
    },
    onConfirmDialogNegBtnClick() {
      this.showConfirmDialog = false;

      if (typeof this.confirmDialogNegBtnHandler !== 'function') {
        this.confirmDialogNegBtnHandler = undefined;
        return;
      }

      this.confirmDialogNegBtnHandler();
    },
    onResetSubscription() {
      this.confirmDialogTitle = this.$translate('RESET_SUBSCRIPTION');
      this.confirmDialogMsg = this.$translate('RESET_SUBSCRIPTION_DIALOG_MSG');
      this.confirmDialogPosBtnText = this.$translate('YES');
      this.confirmDialogNegBtnText = this.$translate('NO');
      this.confirmDialogPosBtnHandler = () => {
        this.resetSubscription();
      };
      this.showConfirmDialog = true;
    },
    resetSubscription() {
      this.resetingSubscription = true;
      const list = this.localShoppingLists[this.selectedShoppingList];
      const payload = { ShoppingListId: list.ShoppingListId };
      resetOrderToShoppingList(payload)
        .then(() => {
          this.getLocalShoppingLists();
          this.resetingSubscription = false;
        })
        .catch(() => {
          this.resetingSubscription = false;
        });
    },
    async orderShoppingListNow(shoppingList) {
      // variable to add orders to payload
      const allEventsForOrder = {};
      // loop through ticket/rental orders and set them in the variable
      this.$store.getters['shoppingCart/orders'].forEach((orderItem) => {
        // to create index in array with that EventId
        if (!allEventsForOrder.hasOwnProperty(orderItem.EventId)) {
          allEventsForOrder[orderItem.EventId] = [];
        }
        // add the items to that index
        allEventsForOrder[orderItem.EventId].push(orderItem.OrderId);
      });

      const payload = {
        ShoppingListId: shoppingList.ShoppingListId,
        Reservations: allEventsForOrder || [],
      };

      this.showProgress = true;
      try {
        const response = await orderShoppingListNow(payload);
        this.showProgress = false;
        const arrayOfReservations = [];
        response.data.UpdatedReservations.forEach((reservation) => {
          const toStoreOrder = {
            EventId: Number(reservation.EventInfo.EventId),
            Picture: reservation.EventInfo.PictureUrl,
            Name: reservation.EventInfo.EventTranslationName,
            Date: new Date(),
            OrderId: reservation.MainOrder.OrderId,
            OrderTotalPrice: reservation.MainOrder.OrderTotalPrice,
            PriceCategories: reservation.MainOrder.PriceCategories,
            Products: reservation.MainOrder.Products,
          };

          if (reservation.EventInfo != null) {
            if (reservation.EventInfo.Type != null) {
              if (reservation.EventInfo.Type === 'Webshop') {
                toStoreOrder.ShoppingCartType = 'Product';
              } else if (reservation.EventInfo.Type === 'Rental') {
                toStoreOrder.ShoppingCartType = 'Rental';
              } else {
                toStoreOrder.ShoppingCartType = 'Ticket';
              }
            }
          } else if (
            reservation.EventType != null &&
            reservation.EventType === 'Rental'
          ) {
            toStoreOrder.ShoppingCartType = 'Rental';
          } else if (
            reservation.EventType != null &&
            reservation.EventType === 'Ticket'
          ) {
            toStoreOrder.ShoppingCartType = 'Ticket';
          } else if (
            reservation.EventType != null &&
            reservation.EventType === 'Product'
          ) {
            toStoreOrder.ShoppingcartType = 'Product';
          }
          arrayOfReservations.push(toStoreOrder);
        });

        this.$store.commit('shoppingCart/setOrders', arrayOfReservations);

        this.setDialog(false);
        this.$router.push({
          name: 'Booking',
        });
      } catch (error) {
        this.showProgress = false;
      }
    },
    goToSubscription() {
      this.$router.push({
        name: 'PartnerGroupSubscription',
      });
    },
    onCreateSubscription() {
      this.setDialog(false);
      this.goToSubscription();
    },
    login() {
      window.EventBus.fire('triggerOpenAccountFromMenu', {
        toggle: true,
        component: 'Login',
      });
    },
    openActivities() {
      this.$router.push({
        name: 'UserSettings',
        params: { myOrders: true },
      });
    },
    getPickupFee() {
      this.pickupFee = null;
      this.minPickupFeeAlert = '';

      const list = this.localShoppingLists[this.selectedShoppingList];
      if (list.Temporary || list.SubEventType !== 'PickUp') {
        return;
      }

      this.pickupFee = new PickupFeeJS(list.SubEventId);
      this.pickupFee.load({}, list.ShoppingListId).then(() => {
        this.minPickupFeeAlert = this.pickupFee.alertText();
      });
    },
    showMinSubscriptionValue(shoppingList) {
      if (shoppingList.Type !== 'Subscription') {
        return false;
      }
      const totalPrice = this.getShoppingListProductsTotalPrice(shoppingList);
      if (
        this.minSubscriptionValue > 0 &&
        totalPrice < this.minSubscriptionValue
      ) {
        return true;
      }
      return false;
    },
    getShoppingListProductsTotalPrice(shoppingList) {
      let totalPrice = 0;

      shoppingList.Products.forEach((product) => {
        totalPrice += product.Price;
      });

      return totalPrice;
    },
  },
};
</script>

<style scoped lang="scss"></style>
